import React from 'react'
import styled from 'styled-components'
import {injectIntl} from 'react-intl'
import image from 'images/image-home-02.png'
import image_retina from 'images/image-home-02@2x.png'
import Arrow from './Arrow'

const Container = styled.div`
    display: flex;
	align-items: center;
    flex-direction: column;
    margin: 50px 0;
	position: fixed;
	z-index: -1;
	left: ${props => props.mobile ? 'calc(50% - 150px)' : `calc(50% - 325px + ${global.SIDE_BAR_SMALL_WIDTH / 2}px)`};
    width: ${props => props.mobile ? '300px' : '650px'};
`

const Text = styled.div`
	font-weight: 700;
	text-align: center;
    font-size: 16px;
`

const Image = styled.img`
	height: ${props => props.mobile ? '200px' : '300px'};
	margin-bottom: 20px;
`

const Icon = styled(Arrow)`
	width: 50px;
	height: 50px;
	margin: 15px;
	flex-shrink: 0;
`

const Descriprion = styled.div`
	position: fixed;
	bottom: 80px;
	left: ${props => props.mobile ? 0 : '150px'};
	display: flex;
`

export default injectIntl(({intl, count, mobile}) =>
	<Container mobile={mobile}>
		<Image src={image} srcSet={`${image_retina} 2x`} alt="" mobile={mobile} />
		<Text>
			{count ? intl.formatMessage({id: "app.restrictive_filters"}) : intl.formatMessage({id: "app.no_records"})}
		</Text>
		{!count &&
			<Descriprion mobile={mobile}>
				<Icon />
				<Text>
					{intl.formatMessage({id: "app.click_to_create"})}
				</Text>
			</Descriprion>
		}
	</Container>
)
